import React from 'react'
import PropTypes from 'prop-types'
import Alert from '../../components/Alert.js'
import LoadingSpinner from '../../components/LoadingSpinner.js'
import RadioButtonGroup from '../../components/RadioButtonGroup.js'
import FormField from '../../components/FormField.js'
import OrderSummary from './OrderSummary.js'
import Confirmation from './Confirmation.js'
import Select from './Select.js'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { CardElement, injectStripe } from 'react-stripe-elements'
import CommentBox from './CommentBox.js'
import {
  getCourses,
  handleSubmit,
  updateBook,
  updatePayNow,
  updateComments,
  updateNumberOfCodes,
  updateContactName,
  updateEmail,
  updateInstitution,
  updatePONumber,
  updateToken,
  updateLoadingStatus,
  setFormError,
} from '../actions'

class OrderInfo extends React.Component {
  static propTypes = {
    courses: PropTypes.array,
    numberOfCodes: PropTypes.number,
    contactName: PropTypes.string,
    email: PropTypes.string,
    institution: PropTypes.string,
    ponumber: PropTypes.string,
    payNow: PropTypes.bool,
    book: PropTypes.object,
    formErrorMsg: PropTypes.string,
    loading: PropTypes.bool,
    finished: PropTypes.bool,
    getCourses: PropTypes.func,
    handleSubmit: PropTypes.func,
    updateBook: PropTypes.func,
    updateNumberOfCodes: PropTypes.func,
    updateContactName: PropTypes.func,
    updateEmail: PropTypes.func,
    updateInstitution: PropTypes.func,
    updatePayNow: PropTypes.func,
    updateComments: PropTypes.func,
    updateToken: PropTypes.func,
    updateLoadingStatus: PropTypes.func,
    setFormError: PropTypes.func,
    comments: PropTypes.string,
  }

  UNSAFE_componentWillMount() {
    this.props.getCourses()
  }

  handleNumberChange = event => {
    let number = parseInt(event.target.value)
    if (number < 0) {
      number = 0
    }
    this.props.updateNumberOfCodes(number)
  }

  handleBookChange = event => {
    let newBook
    for (let i = 0; i < this.props.courses.length; i++) {
      if (this.props.courses[i].id === event.target.value) {
        newBook = this.props.courses[i]
        break
      }
    }
    this.props.updateBook(newBook)
  }

  handleContactNameChange = event => {
    this.props.updateContactName(event.target.value)
  }

  handleEmailChange = event => {
    this.props.updateEmail(event.target.value)
  }

  handleInstitutionChange = event => {
    this.props.updateInstitution(event.target.value)
  }

  handlePONumberChange = event => {
    this.props.updatePONumber(event.target.value)
  }

  handlePayNowChange = event => {
    this.props.updatePayNow(event.target.value)
  }

  handleCommentsChange = event => {
    this.props.updateComments(event.target.value)
  }

  handleSubmit = async event => {
    event.preventDefault()

    if (this.props.book.id === '-1') {
      this.props.setFormError('You must select a book.')
      return
    }

    if (this.props.numberOfCodes < 1) {
      this.props.setFormError('You must order at least 1 code.')
      return
    }

    if (this.props.contactName === '') {
      this.props.setFormError('Contact Name cannot be blank.')
      return
    }

    if (this.props.email === '') {
      this.props.setFormError('Email cannot be blank.')
      return
    }

    if (this.props.institution === '') {
      this.props.setFormError('Institution cannot be blank.')
      return
    }

    if (this.props.payNow) {
      let { token } = await this.props.stripe.createToken({ name: 'Name' })
      this.props.updateToken(token.id)
    }

    this.props.updateLoadingStatus(true)
    this.props.handleSubmit()
  }

  render() {
    if (this.props.finished) {
      return <Confirmation email={this.props.email} />
    }

    if (this.props.loading) {
      return <h4 className="text-dark-blue">Loading...</h4>
    }

    let hasCatalogCourses =
      this.props.courses && this.props.courses.length !== 0
    let selectHtml = hasCatalogCourses ? (
      <Select
        courses={this.props.courses}
        handler={this.handleBookChange}
        book={this.props.book}
      />
    ) : (
      <LoadingSpinner />
    )

    let radioButtonGroupData = [
      {
        name: 'payNow',
        label: 'Pay Now (instant delivery)',
        value: 'true',
        isChecked: this.props.payNow,
        handler: this.handlePayNowChange,
      },
      {
        name: 'payNow',
        label: 'Invoice (delivery in 3-5 business days)',
        value: 'false',
        isChecked: !this.props.payNow,
        handler: this.handlePayNowChange,
      },
    ]

    let total = (
      (this.props.numberOfCodes * this.props.book.price)
    ).toFixed(2)
    let cardHtml = this.props.payNow ? (
      <div className="mb-2">
        <CardElement />
      </div>
    ) : null

    let msg =
      this.props.formErrorMsg === '' ? null : (
        <Alert bootstrapClass="danger" message={this.props.formErrorMsg} />
      )

    return (
      <div>
        {msg}
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label>Book</label>
            {selectHtml}
          </div>
          <FormField
            name="numberOfCodes"
            label="Number of Access Codes"
            value={this.props.numberOfCodes}
            handler={this.handleNumberChange}
            type="number"
          />
          <FormField
            name="contact"
            label="Contact Name"
            value={this.props.contactName}
            handler={this.handleContactNameChange}
            type="text"
          />
          <FormField
            name="email"
            label="Email"
            value={this.props.email}
            handler={this.handleEmailChange}
            type="text"
          />
          <FormField
            name="institution"
            label="Institution"
            value={this.props.institution}
            handler={this.handleInstitutionChange}
            type="text"
            helpText="Access codes are specific to the university bookstore that orders them and cannot be transferred to other universities."
          />
          <FormField
            name="ponumber"
            label="PO Number (optional)"
            value={this.props.ponumber}
            handler={this.handlePONumberChange}
            type="text"
          />
          <CommentBox
            name="comments"
            label="Comments (optional)"
            row="3"
            value={this.props.comments}
            handler={this.handleCommentsChange}
            placeholder="If you have additional questions or comments, you can list them here."
            type="text"
          />
          <RadioButtonGroup buttons={radioButtonGroupData} />
          {cardHtml}
          <OrderSummary
            bookTitle={this.props.book.title}
            numberOfCodes={this.props.numberOfCodes}
            bookPrice={this.props.book.price}
            total={total}
          />
          <button className="btn btn-tomato" type="submit">
            Submit
          </button>
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    courses: state.courses,
    numberOfCodes: state.numberOfCodes,
    contactName: state.contactName,
    email: state.email,
    institution: state.institution,
    ponumber: state.ponumber,
    payNow: state.payNow,
    book: state.book,
    formErrorMsg: state.formErrorMsg,
    loading: state.loading,
    finished: state.finished,
    comments: state.comments,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCourses: () => {
      dispatch(getCourses())
    },
    handleSubmit: () => {
      dispatch(handleSubmit())
    },
    updateBook: book => {
      dispatch(updateBook(book))
    },
    updateNumberOfCodes: numberOfCodes => {
      dispatch(updateNumberOfCodes(numberOfCodes))
    },
    updateContactName: contactName => {
      dispatch(updateContactName(contactName))
    },
    updateEmail: email => {
      dispatch(updateEmail(email))
    },
    updateInstitution: institution => {
      dispatch(updateInstitution(institution))
    },
    updatePONumber: ponumber => {
      dispatch(updatePONumber(ponumber))
    },
    updatePayNow: payNow => {
      dispatch(updatePayNow(payNow))
    },
    updateComments: comments => {
      dispatch(updateComments(comments))
    },
    updateToken: stripeToken => {
      dispatch(updateToken(stripeToken))
    },
    updateLoadingStatus: loading => {
      dispatch(updateLoadingStatus(loading))
    },
    setFormError: formErrorMsg => {
      dispatch(setFormError(formErrorMsg))
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectStripe(OrderInfo))
)
